var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.translate("to-je-začetna-stran")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }